unit View.Api_Cpfs.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UConstantes, UUtils, UPersonalizacao_Tabela.Interfaces,
  UPersonalizacao_Tabela, System.StrUtils, XData.Web.Client, UHelperServer;

type
  TFViewApi_CpfsList = class(TForm)
    Api_CpfsDataset: TXDataWebDataSet;
    Api_CpfsDatasetid: TIntegerField;
    Api_CpfsDatasetcpf: TStringField;
    Api_CpfsDatasetnome: TStringField;
    Api_CpfsDatasetsexo: TStringField;
    Api_CpfsDatasetdata_nascimento: TDateTimeField;
    Api_CpfsDatasetnome_mae: TStringField;
    Api_CpfsDatasetcep: TStringField;
    Api_CpfsDatasetendereco: TStringField;
    Api_CpfsDatasetnumero: TStringField;
    Api_CpfsDatasetbairro: TStringField;
    Api_CpfsDatasetcomplemento: TStringField;
    Api_CpfsDatasettelefone: TStringField;
    Api_CpfsDatasetapi: TStringField;
    Api_CpfsDatasetretorno_api: TStringField;
    Api_CpfsDatasetinclusao: TDateTimeField;
    Api_CpfsDatasetalteracao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    edtRetornoApiCpf: TEdit;
    tmrConsulta: TTimer;
    Api_CpfsDatasetemail: TStringField;
    pnlDadosCpfs: TPanel;
    pnlConsultaDadosCpf: TPanel;
    btnAbrirModalConsultaCpf: TButton;
    btnConsultarCpf: TButton;
    edtCpfConsulta: TEdit;
    edtCodigo: TEdit;
    edtCpf: TEdit;
    edtNome: TEdit;
    edtSexo: TEdit;
    edtDataNascimento: TEdit;
    edtNomeMae: TEdit;
    edtTelefone: TEdit;
    edtEmail: TEdit;
    edtCep: TEdit;
    edtEndereco: TEdit;
    edtNumero: TEdit;
    edtBairro: TEdit;
    edtComplemento: TEdit;
    edtApi: TEdit;
    XDataClientCpf: TXDataWebClient;
    btnAtualizarDadosCpf: TButton;
    procedure WebFormCreate(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure edSearchKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure tmrConsultaTimer(Sender: TObject);
    procedure Api_CpfsDatasetcpfGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure Api_CpfsDatasetcepGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure Api_CpfsDatasettelefoneGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure WebDBTableControl1GetCellClass(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; var AClassName: string);
    procedure btnAbrirModalConsultaCpfClick(Sender: TObject);
    procedure XDataClientCpfError(Error: TXDataClientError);
    procedure XDataClientCpfLoad(Response: TXDataClientResponse);
    procedure btnConsultarCpfClick(Sender: TObject);
    procedure btnAtualizarDadosCpfClick(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
    FPersonalizacaoTabela: IPersonalizacao_Tabela;
    FDadosCpfConsultado : TJSObject;

    procedure LimparCampos;
    procedure SetDadosCpf(pJson : TJSObject);
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewApi_CpfsList: TFViewApi_CpfsList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewApi_CpfsList }

procedure TFViewApi_CpfsList.Api_CpfsDatasetcepGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := TUtils.FormatarCEP(Sender.AsString);
end;

procedure TFViewApi_CpfsList.Api_CpfsDatasetcpfGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := TUtils.FormatarCnpj_Cpf(Sender.AsString);
end;

procedure TFViewApi_CpfsList.Api_CpfsDatasettelefoneGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := TUtils.FormatarTelefone(Sender.AsString);
end;

procedure TFViewApi_CpfsList.btnAbrirModalConsultaCpfClick(Sender: TObject);
begin
  btnAtualizarDadosCpf.Enabled := False;
  edtCpfConsulta.Clear;
  LimparCampos;
  TUtils.OpenModal('modal_consultar_cpf');
end;

procedure TFViewApi_CpfsList.btnAtualizarDadosCpfClick(Sender: TObject);
var
  lJson : TJSObject;
begin
  if Trim(edtCpf.Text) = EmptyStr then
  begin
    TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Nenhum CPF Pesquisado!');
    Exit;
  end;

  lJson := TJSObject.New;

  if TUtils.SomenteNumeros(edtTelefone.Text) <> TUtils.SomenteNumeros(string(FDadosCpfConsultado['telefone'])) then
    lJson['telefone'] := TUtils.SomenteNumeros(edtTelefone.Text);

  if TUtils.SomenteNumeros(edtCep.Text) <> TUtils.SomenteNumeros(string(FDadosCpfConsultado['cep'])) then
    lJson['cep'] := TUtils.SomenteNumeros(edtCep.Text);

  if UpperCase(Trim(edtEmail.Text)) <> UpperCase(Trim(string(FDadosCpfConsultado['email']))) then
    lJson['email'] := UpperCase(Trim(edtEmail.Text));

  if UpperCase(Trim(edtEndereco.Text)) <> UpperCase(Trim(string(FDadosCpfConsultado['endereco']))) then
    lJson['endereco'] := UpperCase(Trim(edtEndereco.Text));

  if UpperCase(Trim(edtNumero.Text)) <> UpperCase(Trim(string(FDadosCpfConsultado['numero']))) then
    lJson['numero'] := UpperCase(Trim(edtNumero.Text));

  if UpperCase(Trim(edtbairro.Text)) <> UpperCase(Trim(string(FDadosCpfConsultado['bairro']))) then
    lJson['bairro'] := UpperCase(Trim(edtbairro.Text));

  if UpperCase(Trim(edtComplemento.Text)) <> UpperCase(Trim(string(FDadosCpfConsultado['complemento']))) then
    lJson['complemento'] := UpperCase(Trim(edtComplemento.Text));

  if TJSJSON.stringify(lJson) = '{}' then
     TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Não existem dados para serem atualizados!')
  else
  begin
    TUtils.ChamarDivLoading;
    lJson['cpf_consulta'] := edtCpf.Text;
    XDataClientCpf.RawInvoke('ISinc_Servidor_Retaguarda_Service.AtualizarDadosCPFApi', [lJson],
      'ATUALIZACAO');
  end;
end;

procedure TFViewApi_CpfsList.btnConsultarCpfClick(Sender: TObject);
var
  lJson : TJSObject;
begin
  if Trim(edtCpfConsulta.Text).IsEmpty then
    TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Preencha o CPF para continuar!')
  else
  begin
    TUtils.ChamarDivLoading;
    lJson := TJSObject.New;
    lJson['cpf_consulta'] := edtCpfConsulta.Text;
    XDataClientCpf.RawInvoke('ISinc_Servidor_Retaguarda_Service.ConsultarCPFApi', [lJson]);
  end;
end;

procedure TFViewApi_CpfsList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewApi_CpfsList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewApi_CpfsList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewApi_CpfsList, AElementID, Result, @AfterCreate);
end;

procedure TFViewApi_CpfsList.edSearchKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Enabled := False;

  if Key = 13 then
  begin
    FGridPlugin.SetFilterText(edSearch.Text, True);
  end;
end;

procedure TFViewApi_CpfsList.edSearchKeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Interval := FTimerConsulta;
  tmrConsulta.Enabled := True;
end;

procedure TFViewApi_CpfsList.LimparCampos;
begin
  edtCodigo.Clear;
  edtCpf.Clear;
  edtNome.Clear;
  edtSexo.Clear;
  edtDataNascimento.Clear;
  edtNomeMae.Clear;
  edtTelefone.Clear;
  edtEmail.Clear;
  edtCep.Clear;
  edtEndereco.Clear;
  edtNumero.Clear;
  edtBairro.Clear;
  edtComplemento.Clear;
  edtApi.Clear;
end;

procedure TFViewApi_CpfsList.SetDadosCpf(pJson: TJSObject);
begin
  FDadosCpfConsultado := pJson;

  edtCodigo.Text := TUtils.FormatarNumeroInteiro(Integer(pJson['id']));
  edtCpf.Text := TUtils.FormatarCnpj_Cpf(string(pJson['cpf']));
  edtNome.Text := string(pJson['nome']);

  if UpperCase(string(pJson['sexo'])) = 'M' then
    edtSexo.Text := 'MASCULINO'
  else
    edtSexo.Text := 'FEMININO';

  edtDataNascimento.Text := THelperServer.ConverterData(string(pJson['data_nascimento']));
  edtNomeMae.Text := THelperServer.GetValorOrEmpty(string(pJson['nome_mae']));
  edtTelefone.Text := THelperServer.GetValorOrEmpty(TUtils.FormatarTelefone(string(pJson['telefone'])));
  edtEmail.Text := THelperServer.GetValorOrEmpty(string(pJson['email']));
  edtCep.Text := THelperServer.GetValorOrEmpty(TUtils.FormatarCEP(string(pJson['cep'])));
  edtEndereco.Text := THelperServer.GetValorOrEmpty(string(pJson['endereco']));
  edtNumero.Text := THelperServer.GetValorOrEmpty(string(pJson['numero']));
  edtBairro.Text := THelperServer.GetValorOrEmpty(string(pJson['bairro']));
  edtComplemento.Text := THelperServer.GetValorOrEmpty(string(pJson['complemento']));
  edtApi.Text := THelperServer.GetValorOrEmpty(string(pJson['api']));
end;

procedure TFViewApi_CpfsList.tmrConsultaTimer(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);

  tmrConsulta.Enabled := False;
  tmrConsulta.Interval := FTimerConsulta;
end;

procedure TFViewApi_CpfsList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordRetornoApi: string;

  procedure RetornoApiButtonClick(Sender: TObject);
  var
    JSONObj: JSValue;
  begin
    JSONObj := TJSJSON.parse(RecordRetornoApi);
    edtRetornoApiCpf.Text := TJSJSON.stringify(JSONObj, nil, 2);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Ação' then
  begin
    RecordRetornoApi := Api_CpfsDataset.FieldByName('retorno_api').AsString;

    Button := TButton.Create(nil);
    Button.Caption := '<i class="fa fa-list"></i>';
    Button.OnClick := @RetornoApiButtonClick;
    Button.ElementClassName := 'btn btn-link btn-primary btn-lg';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.setAttribute('data-bs-toggle', 'tooltip');
    Button.ElementHandle.setAttribute('title', 'Ver Retorno API');
    Button.ElementHandle.setAttribute('data-bs-toggle', 'modal');
    Button.ElementHandle.setAttribute('data-bs-target', '#modal_retorno_api_cpf');
    Button.ElementHandle.setAttribute('data-test', 'btn_visualizar_retorno_api_cpf');
  end;
end;

procedure TFViewApi_CpfsList.WebDBTableControl1GetCellClass(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['nome', 'nome_mae',
      'endereco', 'numero', 'bairro', 'complemento', 'telefone', 'email']) of
      0, 1, 2, 3, 4, 5, 6: AClassName := 'text-start';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewApi_CpfsList.WebFormCreate(Sender: TObject);
begin
  FPersonalizacaoTabela := TPersonalizacao_Tabela.Create(Self.Name, WebDBTableControl1,
    cbPageSize);

  TUtils.SetValorDicionarioClasses('api_cpfs', 'active');
  TUtils.SetValorDicionarioClasses('apis_externas_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_apis_externas', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(WebDBTableControl1, Api_CpfsDataset, lcPaginator,
    lbPaginationInfo);

  FGridPlugin.FDatasetPlugin.FOrderByPadrao := 'id desc';
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewApi_CpfsList.XDataClientCpfError(Error: TXDataClientError);
var
  lErro : string;
  lPosicaoJsonRequisicao,
  lPosicaoJsonResposta: Integer;
begin
  lErro := Error.ErrorMessage;

  lPosicaoJsonResposta := Pos('Json Resposta: ', lErro);

  if lPosicaoJsonResposta > 0 then
  begin
    lErro := Trim(Copy(lErro, 1, lPosicaoJsonResposta - 1));
    lErro := lErro.Replace('Erro: ', '');
  end
  else
  begin
    lPosicaoJsonRequisicao := Pos('Json requisição:', lErro);

    if lPosicaoJsonRequisicao > 0 then
      lErro := Trim(Copy(lErro, 1, lPosicaoJsonRequisicao - 1));
  end;

  TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, lErro);
end;

procedure TFViewApi_CpfsList.XDataClientCpfLoad(Response: TXDataClientResponse);
begin
  btnAtualizarDadosCpf.Enabled := True;
  SetDadosCpf(Response.ResultAsObject);

  if Response.RequestId = 'ATUALIZACAO' then
    TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, 'Dados Atualizados com sucesso!')
  else
  begin
    edSearch.Text := TUtils.SomenteNumeros(edtCpfConsulta.Text);
    FGridPlugin.SetFilterText(TUtils.SomenteNumeros(edtCpfConsulta.Text));
  end;

  FGridPlugin.Load;
end;

procedure TFViewApi_CpfsList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.api_cpfs.list.pagination.info');
  WebDBTableControl1 := TDBTableControl.Create('view.api_cpfs.list.table');
  cbPageSize := TComboBox.Create('view.api_cpfs.list.cbPageSize');
  edSearch := TEdit.Create('view.api_cpfs.list.search');
  lcPaginator := TListControl.Create('view.api_cpfs.list.pagination');
  edtRetornoApiCpf := TEdit.Create('edtRetornoApiCpf');
  pnlDadosCpfs := TPanel.Create(Self);
  pnlConsultaDadosCpf := TPanel.Create(Self);
  btnAbrirModalConsultaCpf := TButton.Create('btnAbrirModalConsultaCpf');
  btnConsultarCpf := TButton.Create('btnConsultarCpf');
  edtCpfConsulta := TEdit.Create('edtCpfConsulta');
  edtCodigo := TEdit.Create('edtCodigo');
  edtCpf := TEdit.Create('edtCpf');
  edtNome := TEdit.Create('edtNome');
  edtSexo := TEdit.Create('edtSexo');
  edtDataNascimento := TEdit.Create('edtDataNascimento');
  edtNomeMae := TEdit.Create('edtNomeMae');
  edtTelefone := TEdit.Create('edtTelefone');
  edtEmail := TEdit.Create('edtEmail');
  edtCep := TEdit.Create('edtCep');
  edtEndereco := TEdit.Create('edtEndereco');
  edtNumero := TEdit.Create('edtNumero');
  edtBairro := TEdit.Create('edtBairro');
  edtComplemento := TEdit.Create('edtComplemento');
  edtApi := TEdit.Create('edtApi');
  btnAtualizarDadosCpf := TButton.Create('btnAtualizarDadosCpf');
  Api_CpfsDataset := TXDataWebDataSet.Create(Self);
  Api_CpfsDatasetid := TIntegerField.Create(Self);
  Api_CpfsDatasetcpf := TStringField.Create(Self);
  Api_CpfsDatasetnome := TStringField.Create(Self);
  Api_CpfsDatasetsexo := TStringField.Create(Self);
  Api_CpfsDatasetdata_nascimento := TDateTimeField.Create(Self);
  Api_CpfsDatasetnome_mae := TStringField.Create(Self);
  Api_CpfsDatasetcep := TStringField.Create(Self);
  Api_CpfsDatasetendereco := TStringField.Create(Self);
  Api_CpfsDatasetnumero := TStringField.Create(Self);
  Api_CpfsDatasetbairro := TStringField.Create(Self);
  Api_CpfsDatasetcomplemento := TStringField.Create(Self);
  Api_CpfsDatasettelefone := TStringField.Create(Self);
  Api_CpfsDatasetemail := TStringField.Create(Self);
  Api_CpfsDatasetapi := TStringField.Create(Self);
  Api_CpfsDatasetretorno_api := TStringField.Create(Self);
  Api_CpfsDatasetinclusao := TDateTimeField.Create(Self);
  Api_CpfsDatasetalteracao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);
  tmrConsulta := TTimer.Create(Self);
  XDataClientCpf := TXDataWebClient.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  edtRetornoApiCpf.BeforeLoadDFMValues;
  pnlDadosCpfs.BeforeLoadDFMValues;
  pnlConsultaDadosCpf.BeforeLoadDFMValues;
  btnAbrirModalConsultaCpf.BeforeLoadDFMValues;
  btnConsultarCpf.BeforeLoadDFMValues;
  edtCpfConsulta.BeforeLoadDFMValues;
  edtCodigo.BeforeLoadDFMValues;
  edtCpf.BeforeLoadDFMValues;
  edtNome.BeforeLoadDFMValues;
  edtSexo.BeforeLoadDFMValues;
  edtDataNascimento.BeforeLoadDFMValues;
  edtNomeMae.BeforeLoadDFMValues;
  edtTelefone.BeforeLoadDFMValues;
  edtEmail.BeforeLoadDFMValues;
  edtCep.BeforeLoadDFMValues;
  edtEndereco.BeforeLoadDFMValues;
  edtNumero.BeforeLoadDFMValues;
  edtBairro.BeforeLoadDFMValues;
  edtComplemento.BeforeLoadDFMValues;
  edtApi.BeforeLoadDFMValues;
  btnAtualizarDadosCpf.BeforeLoadDFMValues;
  Api_CpfsDataset.BeforeLoadDFMValues;
  Api_CpfsDatasetid.BeforeLoadDFMValues;
  Api_CpfsDatasetcpf.BeforeLoadDFMValues;
  Api_CpfsDatasetnome.BeforeLoadDFMValues;
  Api_CpfsDatasetsexo.BeforeLoadDFMValues;
  Api_CpfsDatasetdata_nascimento.BeforeLoadDFMValues;
  Api_CpfsDatasetnome_mae.BeforeLoadDFMValues;
  Api_CpfsDatasetcep.BeforeLoadDFMValues;
  Api_CpfsDatasetendereco.BeforeLoadDFMValues;
  Api_CpfsDatasetnumero.BeforeLoadDFMValues;
  Api_CpfsDatasetbairro.BeforeLoadDFMValues;
  Api_CpfsDatasetcomplemento.BeforeLoadDFMValues;
  Api_CpfsDatasettelefone.BeforeLoadDFMValues;
  Api_CpfsDatasetemail.BeforeLoadDFMValues;
  Api_CpfsDatasetapi.BeforeLoadDFMValues;
  Api_CpfsDatasetretorno_api.BeforeLoadDFMValues;
  Api_CpfsDatasetinclusao.BeforeLoadDFMValues;
  Api_CpfsDatasetalteracao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  tmrConsulta.BeforeLoadDFMValues;
  XDataClientCpf.BeforeLoadDFMValues;
  try
    Name := 'FViewApi_CpfsList';
    Width := 869;
    Height := 374;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 328;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 46;
    WebDBTableControl1.Width := 313;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellClass', 'WebDBTableControl1GetCellClass');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'A'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'C'#243'd.';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cpf';
      Title := 'cpf';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nome';
      Title := 'nome';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'sexo';
      Title := 'sexo';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_nascimento';
      Title := 'Data Nasc.';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nome_mae';
      Title := 'Nome M'#227'e';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cep';
      Title := 'cep';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'endereco';
      Title := 'Endere'#231'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'numero';
      Title := 'N'#250'mero';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'bairro';
      Title := 'bairro';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'complemento';
      Title := 'complemento';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'telefone';
      Title := 'telefone';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'email';
      Title := 'email';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'api';
      Title := 'api';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'Inclus'#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'Altera'#231#227'o';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 19;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 200;
    edSearch.Top := 19;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnKeyDown', 'edSearchKeyDown');
    SetEvent(edSearch, Self, 'OnKeyUp', 'edSearchKeyUp');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 184;
    lcPaginator.Top := 317;
    lcPaginator.Width := 137;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    edtRetornoApiCpf.SetParentComponent(Self);
    edtRetornoApiCpf.Name := 'edtRetornoApiCpf';
    edtRetornoApiCpf.Left := 8;
    edtRetornoApiCpf.Top := 347;
    edtRetornoApiCpf.Width := 121;
    edtRetornoApiCpf.Height := 22;
    edtRetornoApiCpf.ChildOrder := 6;
    edtRetornoApiCpf.Enabled := False;
    edtRetornoApiCpf.HeightPercent := 100.000000000000000000;
    edtRetornoApiCpf.WidthPercent := 100.000000000000000000;
    pnlDadosCpfs.SetParentComponent(Self);
    pnlDadosCpfs.Name := 'pnlDadosCpfs';
    pnlDadosCpfs.Left := 8;
    pnlDadosCpfs.Top := 0;
    pnlDadosCpfs.Width := 313;
    pnlDadosCpfs.Height := 17;
    pnlDadosCpfs.Caption := 'Espa'#231'o tabela dados';
    pnlDadosCpfs.ChildOrder := 23;
    pnlDadosCpfs.Color := clInfoText;
    pnlDadosCpfs.Font.Charset := DEFAULT_CHARSET;
    pnlDadosCpfs.Font.Color := clWhite;
    pnlDadosCpfs.Font.Height := -11;
    pnlDadosCpfs.Font.Name := 'Tahoma';
    pnlDadosCpfs.Font.Style := [fsBold];
    pnlDadosCpfs.ParentFont := False;
    pnlDadosCpfs.TabOrder := 5;
    pnlDadosCpfs.Visible := False;
    pnlConsultaDadosCpf.SetParentComponent(Self);
    pnlConsultaDadosCpf.Name := 'pnlConsultaDadosCpf';
    pnlConsultaDadosCpf.Left := 344;
    pnlConsultaDadosCpf.Top := 0;
    pnlConsultaDadosCpf.Width := 313;
    pnlConsultaDadosCpf.Height := 17;
    pnlConsultaDadosCpf.Caption := 'Espa'#231'o consulta dados';
    pnlConsultaDadosCpf.ChildOrder := 23;
    pnlConsultaDadosCpf.Color := clInfoText;
    pnlConsultaDadosCpf.Font.Charset := DEFAULT_CHARSET;
    pnlConsultaDadosCpf.Font.Color := clWhite;
    pnlConsultaDadosCpf.Font.Height := -11;
    pnlConsultaDadosCpf.Font.Name := 'Tahoma';
    pnlConsultaDadosCpf.Font.Style := [fsBold];
    pnlConsultaDadosCpf.ParentFont := False;
    pnlConsultaDadosCpf.TabOrder := 6;
    pnlConsultaDadosCpf.Visible := False;
    btnAbrirModalConsultaCpf.SetParentComponent(Self);
    btnAbrirModalConsultaCpf.Name := 'btnAbrirModalConsultaCpf';
    btnAbrirModalConsultaCpf.Left := 344;
    btnAbrirModalConsultaCpf.Top := 23;
    btnAbrirModalConsultaCpf.Width := 96;
    btnAbrirModalConsultaCpf.Height := 25;
    btnAbrirModalConsultaCpf.Caption := 'Consultar CPF';
    btnAbrirModalConsultaCpf.ChildOrder := 8;
    btnAbrirModalConsultaCpf.HeightPercent := 100.000000000000000000;
    btnAbrirModalConsultaCpf.WidthPercent := 100.000000000000000000;
    SetEvent(btnAbrirModalConsultaCpf, Self, 'OnClick', 'btnAbrirModalConsultaCpfClick');
    btnConsultarCpf.SetParentComponent(Self);
    btnConsultarCpf.Name := 'btnConsultarCpf';
    btnConsultarCpf.Left := 452;
    btnConsultarCpf.Top := 23;
    btnConsultarCpf.Width := 96;
    btnConsultarCpf.Height := 25;
    btnConsultarCpf.Caption := 'Consultar';
    btnConsultarCpf.ChildOrder := 8;
    btnConsultarCpf.HeightPercent := 100.000000000000000000;
    btnConsultarCpf.WidthPercent := 100.000000000000000000;
    SetEvent(btnConsultarCpf, Self, 'OnClick', 'btnConsultarCpfClick');
    edtCpfConsulta.SetParentComponent(Self);
    edtCpfConsulta.Name := 'edtCpfConsulta';
    edtCpfConsulta.Left := 344;
    edtCpfConsulta.Top := 54;
    edtCpfConsulta.Width := 121;
    edtCpfConsulta.Height := 22;
    edtCpfConsulta.ChildOrder := 10;
    edtCpfConsulta.HeightPercent := 100.000000000000000000;
    edtCpfConsulta.MaxLength := 14;
    edtCpfConsulta.WidthPercent := 100.000000000000000000;
    edtCodigo.SetParentComponent(Self);
    edtCodigo.Name := 'edtCodigo';
    edtCodigo.Left := 344;
    edtCodigo.Top := 82;
    edtCodigo.Width := 121;
    edtCodigo.Height := 22;
    edtCodigo.ChildOrder := 10;
    edtCodigo.Enabled := False;
    edtCodigo.HeightPercent := 100.000000000000000000;
    edtCodigo.Text := 'edtCodigo';
    edtCodigo.WidthPercent := 100.000000000000000000;
    edtCpf.SetParentComponent(Self);
    edtCpf.Name := 'edtCpf';
    edtCpf.Left := 344;
    edtCpf.Top := 110;
    edtCpf.Width := 121;
    edtCpf.Height := 22;
    edtCpf.ChildOrder := 10;
    edtCpf.Enabled := False;
    edtCpf.HeightPercent := 100.000000000000000000;
    edtCpf.Text := 'edtCpf';
    edtCpf.WidthPercent := 100.000000000000000000;
    edtNome.SetParentComponent(Self);
    edtNome.Name := 'edtNome';
    edtNome.Left := 344;
    edtNome.Top := 138;
    edtNome.Width := 121;
    edtNome.Height := 22;
    edtNome.ChildOrder := 10;
    edtNome.Enabled := False;
    edtNome.HeightPercent := 100.000000000000000000;
    edtNome.Text := 'edtNome';
    edtNome.WidthPercent := 100.000000000000000000;
    edtSexo.SetParentComponent(Self);
    edtSexo.Name := 'edtSexo';
    edtSexo.Left := 344;
    edtSexo.Top := 166;
    edtSexo.Width := 121;
    edtSexo.Height := 22;
    edtSexo.ChildOrder := 10;
    edtSexo.Enabled := False;
    edtSexo.HeightPercent := 100.000000000000000000;
    edtSexo.Text := 'edtSexo';
    edtSexo.WidthPercent := 100.000000000000000000;
    edtDataNascimento.SetParentComponent(Self);
    edtDataNascimento.Name := 'edtDataNascimento';
    edtDataNascimento.Left := 344;
    edtDataNascimento.Top := 194;
    edtDataNascimento.Width := 121;
    edtDataNascimento.Height := 22;
    edtDataNascimento.ChildOrder := 10;
    edtDataNascimento.Enabled := False;
    edtDataNascimento.HeightPercent := 100.000000000000000000;
    edtDataNascimento.Text := 'edtDataNascimento';
    edtDataNascimento.WidthPercent := 100.000000000000000000;
    edtNomeMae.SetParentComponent(Self);
    edtNomeMae.Name := 'edtNomeMae';
    edtNomeMae.Left := 344;
    edtNomeMae.Top := 222;
    edtNomeMae.Width := 121;
    edtNomeMae.Height := 22;
    edtNomeMae.ChildOrder := 10;
    edtNomeMae.Enabled := False;
    edtNomeMae.HeightPercent := 100.000000000000000000;
    edtNomeMae.Text := 'edtNomeMae';
    edtNomeMae.WidthPercent := 100.000000000000000000;
    edtTelefone.SetParentComponent(Self);
    edtTelefone.Name := 'edtTelefone';
    edtTelefone.Left := 344;
    edtTelefone.Top := 250;
    edtTelefone.Width := 121;
    edtTelefone.Height := 22;
    edtTelefone.ChildOrder := 10;
    edtTelefone.HeightPercent := 100.000000000000000000;
    edtTelefone.MaxLength := 15;
    edtTelefone.Text := 'edtTelefone';
    edtTelefone.WidthPercent := 100.000000000000000000;
    edtEmail.SetParentComponent(Self);
    edtEmail.Name := 'edtEmail';
    edtEmail.Left := 536;
    edtEmail.Top := 54;
    edtEmail.Width := 121;
    edtEmail.Height := 22;
    edtEmail.CharCase := wecUpperCase;
    edtEmail.ChildOrder := 10;
    edtEmail.HeightPercent := 100.000000000000000000;
    edtEmail.MaxLength := 80;
    edtEmail.Text := 'edtEmail';
    edtEmail.WidthPercent := 100.000000000000000000;
    edtCep.SetParentComponent(Self);
    edtCep.Name := 'edtCep';
    edtCep.Left := 536;
    edtCep.Top := 82;
    edtCep.Width := 121;
    edtCep.Height := 22;
    edtCep.ChildOrder := 10;
    edtCep.HeightPercent := 100.000000000000000000;
    edtCep.MaxLength := 9;
    edtCep.Text := 'edtCep';
    edtCep.WidthPercent := 100.000000000000000000;
    edtEndereco.SetParentComponent(Self);
    edtEndereco.Name := 'edtEndereco';
    edtEndereco.Left := 536;
    edtEndereco.Top := 110;
    edtEndereco.Width := 121;
    edtEndereco.Height := 22;
    edtEndereco.CharCase := wecUpperCase;
    edtEndereco.ChildOrder := 10;
    edtEndereco.HeightPercent := 100.000000000000000000;
    edtEndereco.MaxLength := 100;
    edtEndereco.Text := 'edtEndereco';
    edtEndereco.WidthPercent := 100.000000000000000000;
    edtNumero.SetParentComponent(Self);
    edtNumero.Name := 'edtNumero';
    edtNumero.Left := 536;
    edtNumero.Top := 138;
    edtNumero.Width := 121;
    edtNumero.Height := 22;
    edtNumero.CharCase := wecUpperCase;
    edtNumero.ChildOrder := 10;
    edtNumero.HeightPercent := 100.000000000000000000;
    edtNumero.MaxLength := 20;
    edtNumero.Text := 'edtNumero';
    edtNumero.WidthPercent := 100.000000000000000000;
    edtBairro.SetParentComponent(Self);
    edtBairro.Name := 'edtBairro';
    edtBairro.Left := 536;
    edtBairro.Top := 166;
    edtBairro.Width := 121;
    edtBairro.Height := 22;
    edtBairro.CharCase := wecUpperCase;
    edtBairro.ChildOrder := 10;
    edtBairro.HeightPercent := 100.000000000000000000;
    edtBairro.MaxLength := 80;
    edtBairro.Text := 'edtBairro';
    edtBairro.WidthPercent := 100.000000000000000000;
    edtComplemento.SetParentComponent(Self);
    edtComplemento.Name := 'edtComplemento';
    edtComplemento.Left := 536;
    edtComplemento.Top := 194;
    edtComplemento.Width := 121;
    edtComplemento.Height := 22;
    edtComplemento.CharCase := wecUpperCase;
    edtComplemento.ChildOrder := 10;
    edtComplemento.HeightPercent := 100.000000000000000000;
    edtComplemento.MaxLength := 100;
    edtComplemento.Text := 'edtComplemento';
    edtComplemento.WidthPercent := 100.000000000000000000;
    edtApi.SetParentComponent(Self);
    edtApi.Name := 'edtApi';
    edtApi.Left := 536;
    edtApi.Top := 222;
    edtApi.Width := 121;
    edtApi.Height := 22;
    edtApi.ChildOrder := 10;
    edtApi.Enabled := False;
    edtApi.HeightPercent := 100.000000000000000000;
    edtApi.Text := 'edtApi';
    edtApi.WidthPercent := 100.000000000000000000;
    btnAtualizarDadosCpf.SetParentComponent(Self);
    btnAtualizarDadosCpf.Name := 'btnAtualizarDadosCpf';
    btnAtualizarDadosCpf.Left := 561;
    btnAtualizarDadosCpf.Top := 23;
    btnAtualizarDadosCpf.Width := 96;
    btnAtualizarDadosCpf.Height := 25;
    btnAtualizarDadosCpf.Caption := 'Atualizar';
    btnAtualizarDadosCpf.ChildOrder := 8;
    btnAtualizarDadosCpf.HeightPercent := 100.000000000000000000;
    btnAtualizarDadosCpf.WidthPercent := 100.000000000000000000;
    SetEvent(btnAtualizarDadosCpf, Self, 'OnClick', 'btnAtualizarDadosCpfClick');
    Api_CpfsDataset.SetParentComponent(Self);
    Api_CpfsDataset.Name := 'Api_CpfsDataset';
    Api_CpfsDataset.EntitySetName := 'Api_Cpfs';
    Api_CpfsDataset.Connection := DMConnection.ApiConnection;
    Api_CpfsDataset.Left := 72;
    Api_CpfsDataset.Top := 96;
    Api_CpfsDatasetid.SetParentComponent(Api_CpfsDataset);
    Api_CpfsDatasetid.Name := 'Api_CpfsDatasetid';
    Api_CpfsDatasetid.FieldName := 'id';
    Api_CpfsDatasetid.Required := True;
    Api_CpfsDatasetcpf.SetParentComponent(Api_CpfsDataset);
    Api_CpfsDatasetcpf.Name := 'Api_CpfsDatasetcpf';
    Api_CpfsDatasetcpf.FieldName := 'cpf';
    Api_CpfsDatasetcpf.Required := True;
    SetEvent(Api_CpfsDatasetcpf, Self, 'OnGetText', 'Api_CpfsDatasetcpfGetText');
    Api_CpfsDatasetcpf.Size := 255;
    Api_CpfsDatasetnome.SetParentComponent(Api_CpfsDataset);
    Api_CpfsDatasetnome.Name := 'Api_CpfsDatasetnome';
    Api_CpfsDatasetnome.FieldName := 'nome';
    Api_CpfsDatasetnome.Required := True;
    Api_CpfsDatasetnome.Size := 255;
    Api_CpfsDatasetsexo.SetParentComponent(Api_CpfsDataset);
    Api_CpfsDatasetsexo.Name := 'Api_CpfsDatasetsexo';
    Api_CpfsDatasetsexo.FieldName := 'sexo';
    Api_CpfsDatasetsexo.Size := 255;
    Api_CpfsDatasetdata_nascimento.SetParentComponent(Api_CpfsDataset);
    Api_CpfsDatasetdata_nascimento.Name := 'Api_CpfsDatasetdata_nascimento';
    Api_CpfsDatasetdata_nascimento.FieldName := 'data_nascimento';
    Api_CpfsDatasetdata_nascimento.DisplayFormat := 'dd/mm/yy';
    Api_CpfsDatasetnome_mae.SetParentComponent(Api_CpfsDataset);
    Api_CpfsDatasetnome_mae.Name := 'Api_CpfsDatasetnome_mae';
    Api_CpfsDatasetnome_mae.FieldName := 'nome_mae';
    Api_CpfsDatasetnome_mae.Size := 255;
    Api_CpfsDatasetcep.SetParentComponent(Api_CpfsDataset);
    Api_CpfsDatasetcep.Name := 'Api_CpfsDatasetcep';
    Api_CpfsDatasetcep.FieldName := 'cep';
    SetEvent(Api_CpfsDatasetcep, Self, 'OnGetText', 'Api_CpfsDatasetcepGetText');
    Api_CpfsDatasetcep.Size := 255;
    Api_CpfsDatasetendereco.SetParentComponent(Api_CpfsDataset);
    Api_CpfsDatasetendereco.Name := 'Api_CpfsDatasetendereco';
    Api_CpfsDatasetendereco.FieldName := 'endereco';
    Api_CpfsDatasetendereco.Size := 255;
    Api_CpfsDatasetnumero.SetParentComponent(Api_CpfsDataset);
    Api_CpfsDatasetnumero.Name := 'Api_CpfsDatasetnumero';
    Api_CpfsDatasetnumero.FieldName := 'numero';
    Api_CpfsDatasetnumero.Size := 255;
    Api_CpfsDatasetbairro.SetParentComponent(Api_CpfsDataset);
    Api_CpfsDatasetbairro.Name := 'Api_CpfsDatasetbairro';
    Api_CpfsDatasetbairro.FieldName := 'bairro';
    Api_CpfsDatasetbairro.Size := 255;
    Api_CpfsDatasetcomplemento.SetParentComponent(Api_CpfsDataset);
    Api_CpfsDatasetcomplemento.Name := 'Api_CpfsDatasetcomplemento';
    Api_CpfsDatasetcomplemento.FieldName := 'complemento';
    Api_CpfsDatasetcomplemento.Size := 255;
    Api_CpfsDatasettelefone.SetParentComponent(Api_CpfsDataset);
    Api_CpfsDatasettelefone.Name := 'Api_CpfsDatasettelefone';
    Api_CpfsDatasettelefone.FieldName := 'telefone';
    SetEvent(Api_CpfsDatasettelefone, Self, 'OnGetText', 'Api_CpfsDatasettelefoneGetText');
    Api_CpfsDatasettelefone.Size := 255;
    Api_CpfsDatasetemail.SetParentComponent(Api_CpfsDataset);
    Api_CpfsDatasetemail.Name := 'Api_CpfsDatasetemail';
    Api_CpfsDatasetemail.FieldName := 'email';
    Api_CpfsDatasetemail.Size := 255;
    Api_CpfsDatasetapi.SetParentComponent(Api_CpfsDataset);
    Api_CpfsDatasetapi.Name := 'Api_CpfsDatasetapi';
    Api_CpfsDatasetapi.FieldName := 'api';
    Api_CpfsDatasetapi.Size := 255;
    Api_CpfsDatasetretorno_api.SetParentComponent(Api_CpfsDataset);
    Api_CpfsDatasetretorno_api.Name := 'Api_CpfsDatasetretorno_api';
    Api_CpfsDatasetretorno_api.FieldName := 'retorno_api';
    Api_CpfsDatasetretorno_api.Size := 255;
    Api_CpfsDatasetinclusao.SetParentComponent(Api_CpfsDataset);
    Api_CpfsDatasetinclusao.Name := 'Api_CpfsDatasetinclusao';
    Api_CpfsDatasetinclusao.FieldName := 'inclusao';
    Api_CpfsDatasetinclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    Api_CpfsDatasetalteracao.SetParentComponent(Api_CpfsDataset);
    Api_CpfsDatasetalteracao.Name := 'Api_CpfsDatasetalteracao';
    Api_CpfsDatasetalteracao.FieldName := 'alteracao';
    Api_CpfsDatasetalteracao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := Api_CpfsDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 152;
    tmrConsulta.SetParentComponent(Self);
    tmrConsulta.Name := 'tmrConsulta';
    tmrConsulta.Enabled := False;
    SetEvent(tmrConsulta, Self, 'OnTimer', 'tmrConsultaTimer');
    tmrConsulta.Left := 241;
    tmrConsulta.Top := 208;
    XDataClientCpf.SetParentComponent(Self);
    XDataClientCpf.Name := 'XDataClientCpf';
    XDataClientCpf.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientCpf, Self, 'OnLoad', 'XDataClientCpfLoad');
    SetEvent(XDataClientCpf, Self, 'OnError', 'XDataClientCpfError');
    XDataClientCpf.Left := 512;
    XDataClientCpf.Top := 272;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    edtRetornoApiCpf.AfterLoadDFMValues;
    pnlDadosCpfs.AfterLoadDFMValues;
    pnlConsultaDadosCpf.AfterLoadDFMValues;
    btnAbrirModalConsultaCpf.AfterLoadDFMValues;
    btnConsultarCpf.AfterLoadDFMValues;
    edtCpfConsulta.AfterLoadDFMValues;
    edtCodigo.AfterLoadDFMValues;
    edtCpf.AfterLoadDFMValues;
    edtNome.AfterLoadDFMValues;
    edtSexo.AfterLoadDFMValues;
    edtDataNascimento.AfterLoadDFMValues;
    edtNomeMae.AfterLoadDFMValues;
    edtTelefone.AfterLoadDFMValues;
    edtEmail.AfterLoadDFMValues;
    edtCep.AfterLoadDFMValues;
    edtEndereco.AfterLoadDFMValues;
    edtNumero.AfterLoadDFMValues;
    edtBairro.AfterLoadDFMValues;
    edtComplemento.AfterLoadDFMValues;
    edtApi.AfterLoadDFMValues;
    btnAtualizarDadosCpf.AfterLoadDFMValues;
    Api_CpfsDataset.AfterLoadDFMValues;
    Api_CpfsDatasetid.AfterLoadDFMValues;
    Api_CpfsDatasetcpf.AfterLoadDFMValues;
    Api_CpfsDatasetnome.AfterLoadDFMValues;
    Api_CpfsDatasetsexo.AfterLoadDFMValues;
    Api_CpfsDatasetdata_nascimento.AfterLoadDFMValues;
    Api_CpfsDatasetnome_mae.AfterLoadDFMValues;
    Api_CpfsDatasetcep.AfterLoadDFMValues;
    Api_CpfsDatasetendereco.AfterLoadDFMValues;
    Api_CpfsDatasetnumero.AfterLoadDFMValues;
    Api_CpfsDatasetbairro.AfterLoadDFMValues;
    Api_CpfsDatasetcomplemento.AfterLoadDFMValues;
    Api_CpfsDatasettelefone.AfterLoadDFMValues;
    Api_CpfsDatasetemail.AfterLoadDFMValues;
    Api_CpfsDatasetapi.AfterLoadDFMValues;
    Api_CpfsDatasetretorno_api.AfterLoadDFMValues;
    Api_CpfsDatasetinclusao.AfterLoadDFMValues;
    Api_CpfsDatasetalteracao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
    tmrConsulta.AfterLoadDFMValues;
    XDataClientCpf.AfterLoadDFMValues;
  end;
end;

end.
